import { getBearerToken } from './parts/getBearerToken';
import { getTranslatedQuery } from './parts/getTranslatedQuery';
import { downloadData } from './parts/downloadData';
import downloadFile from '../../utils/downloadFile';
import { DownloadButtonProps } from '@/types/download/DownloadButtonProps';
import { useToast } from '@/storybook/components/Toast/Toast';
import { CubejsApi } from '@cubejs-client/core';
import { CubeQuery } from '@/types/cube';

export const useDownloadDataButton = ({
  cubejsApi,
  baseQuery,
  queryFilters,
  dateRange,
  translationsMap,
  fileNamePrefix,
  additionalQueryParser,
  mergeValues,
}: Omit<DownloadButtonProps, 'disabled'>) => {
  const { makeToast } = useToast();
  return async () => {
    try {
      const bearerToken = await getBearerToken();
      const translatedQuery = await getTranslatedQuery({
        queryFilters,
        cubejsApi,
        baseQuery,
        translationsMap,
        dateRange,
        fileNamePrefix,
        additionalQueryParser,
      });
      const fileUrl = await downloadData({ bearerToken, fileNamePrefix, translatedQuery, mergeValues });
      if (fileUrl) {
        await downloadFile(fileUrl);
        makeToast({ content: 'File downloaded successfully', appearance: 'success' });
      } else {
        makeToast({ content: 'File download filed', appearance: 'error' });
      }
    } catch (error) {
      makeToast({ content: 'Unable to download item. Please try again later.', appearance: 'error' });
      throw error;
    }
  };
};

const mockCubejsApi = {} as CubejsApi;

const mockBaseQuery: CubeQuery = {
  measures: [],
  dimensions: ['Users.city'],
  limit: 500,
  filters: [],
  timeDimensions: [],
  order: {},
};

export const MOCK_DOWNLOAD_BUTTON_PROPS: DownloadButtonProps = {
  baseQuery: mockBaseQuery,
  cubejsApi: mockCubejsApi,
  queryFilters: { and: [] },
  dateRange: { dimension: 'test', dateRange: 'last 30 days' },
  translationsMap: {},
  fileNamePrefix: 'test',
};
